// Riapre il pannello preferenze di iubenda; se iubenda non è ancora pronto riprova per qualche secondo
export const openCookiePreferences = () => {
  let tries = 0;
  const attempt = () => {
    const api = window._iub?.cs?.api;
    if (api?.openPreferences) {
      api.openPreferences();
      return;
    }
    if (tries++ < 20) setTimeout(attempt, 250);
  };
  attempt();
};

export const CookiePreferencesLink = ({ className = '', children = 'Preferenze cookie', testId = 'cookie-preferences-link' }) => (
  <button type="button" onClick={openCookiePreferences} className={className} data-testid={testId}>
    {children}
  </button>
);
